import React, { useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useTenantConfig } from "../context/TenantConfigContext";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { tenantConfig } = useTenantConfig();
  const isBasePath = location.pathname === '/';
  const tenantName = tenantConfig.tenantDisplayName || "Champions Funding";
  const headerLogoUrl =
    tenantConfig.loginLogoUrl || "/images/champs/Champs-Logo-Clr.png";

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <div className="w-full">
      {isBasePath && (
        <button
          onClick={handleLoginClick}
          className="absolute top-4 right-4 border-2 border-[var(--tenant-primary-color)] text-[var(--tenant-primary-color)] font-semibold py-1 px-2 rounded-md hover:bg-[var(--tenant-primary-soft-color)] items-center justify-center px-4 py-2 inline-flex btn-primary"
        >
          Login
        </button>
      )}
      {/* Top Bar */}
      <div className="bg-top-bar text-sm py-1">
        {/* <div className="container mx-auto px-4 flex justify-between items-center">
                    <div className="flex space-x-4">
                        <a href="#" className="hover:text-[var(--tenant-primary-color)]">View Today's Turn Times</a>
                        <a href="#" className="hover:text-[var(--tenant-primary-color)]">Current Closing Schedule</a>
                    </div>
                    <div className="flex items-center space-x-4">
                        <span>LOCK DESK HOURS: 8am - 5pm PT</span>
                        <div className="flex space-x-4">
                            <a href="#" className="hover:text-[var(--tenant-primary-color)]">Partner With Us</a>
                            <a href="#" className="hover:text-[var(--tenant-primary-color)]">Contact Us</a>
                        </div>
                    </div>
                </div> */}
      </div>

      {/* Main Header */}
      <header className="bg-headerhead shadow-sm">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <div className="flex items-center">
              <a
                href="/"
                rel="noreferrer"
                className="flex items-center gap-3"
              >
                <img
                  src={headerLogoUrl}
                  alt={`${tenantName} logo`}
                  className="h-10 w-auto"
                />
                {/* <span className="text-lg font-semibold text-heading">{tenantName}</span> */}
              </a>
            </div>

            {/* Desktop Navigation */}
            {/* <nav className="hidden lg:flex items-center space-x-8">
                            <div className="relative group">
                                <button
                                    className="flex items-center space-x-1 text-[#222222] hover:text-[var(--tenant-primary-color)]"
                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                >
                                    <span>About</span>
                                    <span className="text-xs">▼</span>
                                </button>
                            </div>
                            <a href="#" className="text-[#222222] hover:text-[var(--tenant-primary-color)]">Product Overview</a>
                            <a href="#" className="text-[#222222] hover:text-[var(--tenant-primary-color)]">Broker Resources</a>
                            <a href="#" className="text-[#222222] hover:text-[var(--tenant-primary-color)]">Wholesale Quick Pricer</a>
                        </nav> */}

            {/* Right Side Buttons */}
            {/* <div className="hidden lg:flex items-center space-x-4">
                            <button className="bg-[#90EE90] text-white px-6 py-2 rounded-full hover:bg-white hover:text-[var(--tenant-primary-color)] transition-colors">
                                HERO Login
                            </button>
                            <button className="p-2">
                                <Search className="w-6 h-6 text-[#222222] hover:text-[var(--tenant-primary-color)]" />
                            </button>
                            <button className="p-2">
                                <Menu className="w-6 h-6 text-[#222222] hover:text-[var(--tenant-primary-color)]" />
                            </button>
                        </div> */}

            {/* Mobile Menu Button */}
            {/* <button
                            className="lg:hidden p-2"
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                        >
                            {isMenuOpen ? (
                                <X className="w-6 h-6 text-[#222222]" />
                            ) : (
                                <Menu className="w-6 h-6 text-[#222222]" />
                            )}
                        </button> */}
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white">
          <div className="container mx-auto px-4 py-4">
            <nav className="flex flex-col space-y-4">
              <a href="#" className="nav-link">
                About
              </a>
              <a href="#" className="nav-link">
                Product Overview
              </a>
              <a href="#" className="nav-link">
                Broker Resources
              </a>
              <a href="#" className="nav-link">
                Wholesale Quick Pricer
              </a>
              <button className="btn-hero-login w-full">HERO Login</button>
            </nav>
          </div>
        </div>
      )}

      {/* Banner */}
      {/* <div className="bg-banner py-4 text-center">
        <div className="container mx-auto px-4">
          <p className="text-banner-text">
            Our loan product guidelines are a GAMECHANGER!
          
          </p>
        </div>
      </div> */}
    </div>
  );
};

export default Header;
